import styled, { css } from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.grey100};
  min-height: calc(100vh - 50px);
`;

export const Center = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Img = styled.img`
  height: ${props => props.height || 'auto'};
  display: block;
  margin: auto;
`;

export const Text = styled(typography.TitleOneRegularTypography)`
  margin: 10px 0;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const Button = styled.button`
  bottom: 40px;
  right: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.blueMain};
  border: 1px solid ${({ theme }) => theme.colors.grey007};
  border-radius: 8px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.white};
`;

export const InputLabel = styled(typography.BodyTextOneBoldTypography)`
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const InputStyle = css`
  width: 80%;
  height: 45px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme, error }) => (error ? theme.colors.redMain : theme.colors.grey003)};
  border-radius: 4px;
  box-sizing: border-box;

  &::placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey005};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.blueMain};
    outline: none;
  }
`;

export const Input = styled.input`
  ${InputStyle}
  padding: 8px 8px;
`;

export const extedntModalContentStyle = css`
  width: 680px;
`;

export const extendModalTitleStyle = css`
  padding: 16px 16px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey003};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const extendModalBodyStyle = css`
  padding: 0;
`;

export const ModalContainer = styled.div`
  padding: 16px;
`;

export const ButtonsContainer = styled.div`
  padding: 16px;
  display: flex;
  justify-content: flex-end;
`;

export const CancelButton = styled.button`
  bottom: 40px;
  right: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.grey100};
  border: 1px solid ${({ theme }) => theme.colors.grey003};
  border-radius: 8px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey600};
  margin-inline-end: 7px;
`;

export const ConfirmButton = styled.button`
  bottom: 40px;
  right: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.blueMain};
  border: 1px solid ${({ theme }) => theme.colors.grey007};
  border-radius: 8px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.white};
`;

export const SelectInput = styled.select`
  ${InputStyle}
  option {
    font-size: 18px;
    font-family: 'Open Sans', sans-serif;
    color: #555;
    background-color: rgb(247, 247, 247);
    background-image: none;
    font-size: 18px;
    height: 50px;
    padding: 15px;
    border: 1px solid rgb(41, 18, 18);
  }
`;

export const Wrapper = styled.div`
  width: 98%;
  padding: 16px;
`;

export const ShowMoreButton = styled(typography.TitleTwoTypography)`
  display: flex;
  height: 48px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grey600};
  cursor: pointer;
`;

export const extendBlueButtonStyle = css`
  width: 120px;
  border-radius: 8px;
  border: 1px solid #e3e6ea;
  background: #0070cd;
  color: #fff;
  padding: 7px 10px;
`;

export const extendLoaderStyle = css`
  height: 16px;
  width: 17px;
  border: 1px solid #f3f3f3;
  border-top: 3px solid #3498db;
  margin: 0;
`;
